import { useCallback } from 'react';

import { create } from 'zustand';

import { Icons } from 'app/constants/icons';
import { useAuthentication } from 'app/hooks/useAuthentication';
import { useIsMobile } from 'app/hooks/useIsMobile';
import { cn } from 'app/utils/styles.utils';
import { Button } from 'app/shared/buttons/Button';
import { AuthButton } from './AuthButton';

type MobileMenuState = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const useMobileMenu = create<MobileMenuState>(set => ({
  open: false,
  setOpen: (open: boolean) => set({open}),
}));

export const MobileMenu = () => {
  const open = useMobileMenu(state => state.open);
  const setOpen = useMobileMenu(state => state.setOpen);
  const {connected} = useAuthentication();

  const isMobile = useIsMobile();

  const handleMenuButton = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  if (!isMobile) return null;

  return (
    <>
      <Button
        className="flex h-full pl-2 transition-all hover:opacity-90 active:opacity-80"
        onClick={handleMenuButton}
        aria-label="Disconnect">
        <Icons.lines className="text-neutral-300" />
      </Button>

      <div
        onClick={handleMenuButton}
        className={cn(
          'fixed left-0 top-0 flex h-[100svh] w-full transition-all duration-[0.3s]',
          {
            'bg-black/60': open,
            'bg-black/0': !open,
            'translate-x-full': !open,
            'translate-x-0': open,
          },
        )}>
        <div
          onClick={e => e.stopPropagation()}
          className="absolute right-0 top-0 flex h-full w-[90%] max-w-[300px] flex-col gap-2.5 rounded-l-[12px] bg-neutral-1000 px-[25px] pb-[25px] pt-3.75">
          <div className="flex w-full flex-none items-center justify-between">
            <span className="text-3xs font-semibold leading-normal text-charcoal-500">
              MENU
            </span>

            <button onClick={handleMenuButton} className="py-3.5 pl-4 pr-0.5">
              <Icons.chevronRight size={16} strokeWidth={3} />
            </button>
          </div>

          <div className="flex flex-1 flex-col justify-between">
            {/* <div className="flex flex-col">
              <HeaderButtons />
            </div> */}

            <div className="flex flex-col pb-3">
              <div className="mb-6 h-px w-full bg-charcoal-600" />

              <div className="flex justify-end">
                {connected && <AuthButton iconSize={24} isOnlyIcon />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
